
import { Calendar, MapPin, UsersIcon, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Event {
  title: {
    en: string;
    ar: string;
  };
  date: {
    en: string;
    ar: string;
  };
  location: {
    en: string;
    ar: string;
  };
  attendees: number;
  startTime?: {
    en: string;
    ar: string;
  };
  endTime?: {
    en: string;
    ar: string;
  };
  remainingDays?: number;
  remainingHours?: number;
  remainingMinutes?: number;
}

export const EventDetails = ({ event, isRTL }: { event: Event; isRTL: boolean }) => {
  const addToGoogleCalendar = (event: Event) => {
    const title = encodeURIComponent(event.title[isRTL ? "ar" : "en"]);
    const location = encodeURIComponent(event.location[isRTL ? "ar" : "en"]);
    const dates = encodeURIComponent(event.date[isRTL ? "ar" : "en"]);
    
    const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&location=${location}&dates=${dates}`;
    window.open(url, '_blank');
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h3 className="font-semibold text-lg">
          {isRTL ? "معلومات الفعالية" : "Event Information"}
        </h3>
        <p className="text-muted-foreground">
          {event.title[isRTL ? "ar" : "en"]}
        </p>
        <div className="flex items-center gap-2 text-primary">
          <Calendar className="w-4 h-4" />
          {event.date[isRTL ? "ar" : "en"]}
        </div>
        {event.startTime && event.endTime && (
          <div className="flex items-center gap-2 text-primary">
            <Clock className="w-4 h-4" />
            {event.startTime[isRTL ? "ar" : "en"]} - {event.endTime[isRTL ? "ar" : "en"]}
          </div>
        )}
        <div className="flex items-center gap-2 text-primary">
          <MapPin className="w-4 h-4" />
          {event.location[isRTL ? "ar" : "en"]}
        </div>
        <div className="flex items-center gap-2 text-primary">
          <UsersIcon className="w-4 h-4" />
          {event.attendees} {isRTL ? "مشارك" : "attendees"}
        </div>
        {event.remainingDays !== undefined && (
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="font-semibold mb-2">
              {isRTL ? "الوقت المتبقي" : "Time Remaining"}
            </h4>
            <div className="flex gap-4 justify-center text-center">
              <div>
                <div className="text-2xl font-bold text-primary">{event.remainingDays}</div>
                <div className="text-sm text-gray-600">{isRTL ? "يوم" : "Days"}</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-primary">{event.remainingHours}</div>
                <div className="text-sm text-gray-600">{isRTL ? "ساعة" : "Hours"}</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-primary">{event.remainingMinutes}</div>
                <div className="text-sm text-gray-600">{isRTL ? "دقيقة" : "Minutes"}</div>
              </div>
            </div>
          </div>
        )}
        <Button
          variant="outline"
          className="w-full mt-4"
          onClick={() => addToGoogleCalendar(event)}
        >
          <Calendar className="w-4 h-4 mr-2" />
          {isRTL ? "إضافة إلى تقويم جوجل" : "Add to Google Calendar"}
        </Button>
      </div>
      <div className="pt-4 border-t">
        <h3 className="font-semibold text-lg mb-2">
          {isRTL ? "للتواصل" : "Contact Information"}
        </h3>
        <div className="flex items-center gap-2 text-primary">
          <a href="mailto:info@fkrah.sa" className="hover:underline">
            info@fkrah.sa
          </a>
        </div>
      </div>
    </div>
  );
};
